<template>
  <el-tooltip
    :content="content"
    :disabled="disabled"
    :placement="placement"
    class="tooltip"
  >
    <slot ref="content"></slot>
  </el-tooltip>
</template>

<script>
export default {
  name: "AutoToolTip",
  props: {
    content: { type: String, default: "" }, // 字符内容
    placement: { type: String, default: "top-start" },
  },
  computed: {
    disabled() {
      //   const content = this.$refs.content
      //   console.log(content)
      //   return true
      // //   console.log(content)
      // //    return  !(content.scrollWidth > content.clientWidth)
      return true;
    },
  },

  mounted() {
    setTimeout(() => {
      console.log(this.$slots[0].element);
      console.log(this.$slots[0].element.clientWidth);
      // console.log(this.$refs.content.scrollWidth)
      // this.$refs.content.scrollWidth
      // this.$refs.content.scrollWidth
    }, 1000);
  },
};
</script>
